import { useQuery } from "react-query";
import axios from '../axios';

const useGetRequests = (seller_id, sort, search) => {
  const query = useQuery(
    ["requests", seller_id, sort, search],
    async () => {
      try {
        return await axios.get(
          `/api/requests?requested_by=${seller_id}&sort=${sort}&description=${search}`
        );
      } catch (error) {
        console.log(error);
      }
    },
    {
      enabled: !!seller_id, // ensure seller_id exists
    }
  );

  return query;
};

export default useGetRequests;